import React from 'react';
import fisioImage from '../../src/assets/FisioChore.jpg';

const FisioWhyUs = () => {
    return (
        <section className="py-16 bg-white">
            <div className="container mx-auto px-4">
                <h2 className="text-xl font-bold text-center text-gray-800 mb-12">
                    ¿Por qué elegirnos?
                </h2>
                <div className="flex flex-col md:flex-row items-center justify-center gap-12">
                    <div className="md:w-1/2">
                        <img 
                            src={fisioImage}
                         //   className="h-64 w-64 mr-3"

                            alt="Fisioterapeuta trabajando"
                           
                        />
                    </div>
                    <div className="md:w-1/2 space-y-4 text-gray-700 text-lg">
                        <p>
                            En <span className="font-semibold text-blue-600">Fisio Life</span>, entendemos que tu salud y bienestar son lo más importante.
                        </p>
                        <p>
                           Nuestros fisioterapeutas altamente calificados utilizan las técnicas más innovadoras y un enfoque personalizado para ayudarte a recuperar tu movilidad, aliviar el dolor y mejorar tu calidad de vida, asegurando tratamientos efectivos y adaptados a tus necesidades específicas.                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default FisioWhyUs;